<div class="tool-content-container">
  <div class="tool-description">
    To generate ranking for the list of courses you have. Start by entering the
    course number of a course and click the 'add course' button.
  </div>

  <back-button></back-button>
</div>
